import React from 'react';
import { LearnMoreTopic, Plan, SetPlanScreen } from '..';
import CheckListItem from '../../../../components/UI/CheckListItem';
import css from '../../../../components/UI/CheckListItem/CheckListItem.module.scss';
import { SavingsRewards } from '../../../../utils/prices';

const FamilyLocationSharingItem = ({
  plan,
  onLearnMoreClicked
}: {
  plan: Plan;
  onLearnMoreClicked: (learnMoreTopic: LearnMoreTopic, plan: Plan) => void;
}) => (
  <CheckListItem
    redesignCheckListItem={true}
    hasLink={true}
    data-e2e="family-location-sharing-bullet"
  >
    <p>
      Family location sharing
      <a
        className={css.learnMoreButton}
        data-e2e="family-location-sharing-learn-more-button"
        data-testid="family-location-sharing-learn-more-button"
        onClick={e => {
          e.preventDefault();
          onLearnMoreClicked(
            SetPlanScreen.LocationSharingLearnMoreScreen,
            plan
          );
        }}
      >
        Learn more
      </a>
    </p>
  </CheckListItem>
);

export const infinityChecklist = (
  onLearnMoreClicked: (learnMoreTopic: LearnMoreTopic, plan: Plan) => void
) => (
  <>
    <CheckListItem>
      <p>
        <span className={css.boldWithUnderline}>5%</span> on savings,{' '}
        <span className={css.boldWithUnderline}>1%</span> cash back*
      </p>
    </CheckListItem>
    <CheckListItem>
      <p>{`Investing for parents & kids`}</p>
    </CheckListItem>
    <CheckListItem>
      <p>{`Identity theft, cell phone & purchase protection**`}</p>
    </CheckListItem>
    <FamilyLocationSharingItem
      onLearnMoreClicked={onLearnMoreClicked}
      plan={Plan.infinity}
    />
    <CheckListItem>
      <p>SOS alerts</p>
    </CheckListItem>
    <CheckListItem>
      <p>Crash detection</p>
    </CheckListItem>
  </>
);

export const maxChecklist = (savings: SavingsRewards) =>  (
  <>
    <CheckListItem>
      <p>
        <span className={css.boldNoUnderline}>{savings.max}</span> on savings,{' '}
        <span className={css.boldNoUnderline}>1%</span> cash back*
      </p>
    </CheckListItem>
    <CheckListItem>
      <p>{`Investing for parents & kids`}</p>
    </CheckListItem>
    <CheckListItem>
      <p>{`Identity theft, cell phone & purchase protection**`}</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true} image="lock">
      <p>Family location sharing</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true} image="lock">
      <p>SOS alerts</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true} image="lock">
      <p>Crash detection</p>
    </CheckListItem>
  </>
);

export const infinityChoosePlanChecklist = (
  <>
    <CheckListItem>
      <p>
        <span className={css.boldWithUnderline}>5%</span> on savings,{' '}
        <span className={css.boldWithUnderline}>1%</span> cash back*
      </p>
    </CheckListItem>
    <CheckListItem>
      <p>{`Investing for parents & kids`}</p>
    </CheckListItem>
    <CheckListItem>
      <p>{`Identity theft, cell phone & purchase protection**`}</p>
    </CheckListItem>
    <CheckListItem>
      <p>Family location sharing</p>
    </CheckListItem>
    <CheckListItem>
      <p>SOS alerts</p>
    </CheckListItem>
    <CheckListItem>
      <p>Crash detection</p>
    </CheckListItem>
  </>
);

export const maxChoosePlanChecklist = (savings: SavingsRewards) => (
  <>
    <CheckListItem>
      <p>Debit card & educational app</p>
    </CheckListItem>
    <CheckListItem>
      <p>{savings.max} Savings Rewards*</p>
    </CheckListItem>
    <CheckListItem>
      <p>Investing for parents & kids</p>
    </CheckListItem>
    <CheckListItem>
      <p>1% Cash Back</p>
    </CheckListItem>
    <CheckListItem>
      <p>Identity protection**</p>
    </CheckListItem>
    <CheckListItem>
      <p>Purchase protection**</p>
    </CheckListItem>
  </>
);

export const standardChoosePlanChecklist = (savings: SavingsRewards) => (
  <>
    <CheckListItem>
      <p>Debit card & educational app</p>
    </CheckListItem>
    <CheckListItem>
      <p>{savings.core} Savings Rewards*</p>
    </CheckListItem>
    <CheckListItem>
      <p>Limited investing for parents</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true} image="lock">
      <p>Protection plans & perks**</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true} image="lock">
      <p>Family location sharing</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true} image="lock">
      <p>Driving safety and SOS</p>
    </CheckListItem>
  </>
);

export const deafultMaxPlanCheckList = (savings: SavingsRewards) => (
  <>
    <CheckListItem>
      <p>Debit cards for up to 5 kids</p>
    </CheckListItem>
    <CheckListItem>
      <p>Educational app to send money, manage chores, and more</p>
    </CheckListItem>
    <CheckListItem>
      <p>Investing for parents & kids</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true}>
      <p>1% on cash back, {savings.max} on savings**</p>
    </CheckListItem>
    <CheckListItem redesignCheckListItem={true}>
      <p>Identity theft, cell phone, and purchase protection***</p>
    </CheckListItem>
  </>
);

export const defaultInfinityPlanChecklist = () => (
  <>
    <CheckListItem>
      <p>Debit cards for up to 5 kids</p>
    </CheckListItem>
    <CheckListItem>
      <p>Educational app to send money, manage chores, and more</p>
    </CheckListItem>
    <CheckListItem>
      <p>
        <span className={css.boldNoUnderline}> 5% </span>
        on savings, <span className={css.boldNoUnderline}> 1% </span>
        on cash back<sup>1</sup>
      </p>
    </CheckListItem>
    <CheckListItem>
      <p>Investing for parents & kids</p>
    </CheckListItem>
    <CheckListItem>
      <p>
        Family location sharing, SOS alerts, Crash detection<sup>2</sup>
      </p>
    </CheckListItem>
    <CheckListItem>
      <p>
        Identity theft, cell phone & purchase protection<sup>3</sup>
      </p>
    </CheckListItem>
  </>
);

export const corePlanCheckList = (savings: SavingsRewards) => (
  <>
    <CheckListItem>
      <p>Debit card and app for kids and parents</p>
    </CheckListItem>
    <CheckListItem>
      <p>Educational app to send money, manage chores, and more</p>
    </CheckListItem>
    <CheckListItem>
      <p>{savings.core} on savings, 1% cash back*</p>
    </CheckListItem>
  </>
);
